<template>
  <span>{{ formattedTimestamp }}</span>
</template>

<script>
import moment from 'moment';

export default {
  name: 'SoftwareAppsStatusTimestamp',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    formattedTimestamp() {
      return moment.utc(this.item.timestamp).format('YYYY-MM-DD @ h:mm A');
    },
  },

};

</script>
